import { Component, OnInit, Input } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { CommercialCompetenceService } from '../../services/commercial-competence.service';

@Component({
	selector: 'app-competence-proposal-log',
	templateUrl: './proposal-log.component.html',
	providers: [
		HttpModule
	]
})
export class CompetenceProposalLogComponent implements OnInit {
	private token;
	public logs: any[];
	public permissoes: any[] = [];

	@Input('proposalID') proposalID: string = "";

	private dateTest: Date;

	constructor(private commercialCompetenceService: CommercialCompetenceService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
	}

	getProposalLog() {
		this.commercialCompetenceService.getProposalLog(this.proposalID).subscribe(result => {
			if (result.Success) {
				console.log("Log da Proposta", result.Result);
				this.logs = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.getProposalLog();
	}

}



// WEBPACK FOOTER //
// ./src/app/commercial-competence/commercial-competence/log/proposal-log.component.ts